import { useDialog } from "../../hooks/useDialog"

export const Confirm = ({data}) => {

    const dialog = useDialog()

    return (
        <>
        <span className="ti ti-info"></span>
        <p>{data.message || "¿Está seguro?"}</p>
        <div className="actions-container">
            <button type="button" className="btn" onClick={() => dialog.close()}>
                Cancelar
            </button>
            <button type="button" className="btn rmb-btn-primary" onClick={() => {
                dialog.close()
                if (typeof data.callback === "function") data.callback()
            }}>
                Confirmar
            </button>
        </div>
        </>
    )
}